import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const omeletAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.FlyersAdmin, Permission.Admin, Permission.Flyers],
}
